import React from "react";
import { GetStaticPaths, GetStaticProps, NextPage } from "next";
import ApiEngine from "../api-engine";
import { IPageLayoutProps } from "../components/PageLayout";
import TemplatePageComponent from "../components/pages/TemplatePageComponent";
import NavigationProvider from "../context/NavigationContext";
import { ApiPage } from "../models/api/page.model";

export interface ITemplatePageProps extends IPageLayoutProps {
  content: ApiPage;
}

const TemplatePage: NextPage<ITemplatePageProps> = (props) => {
  return (
    // TODO, avoid in all pages to set NavigationProvider here, but instead create a HOC for PageLayout
    <NavigationProvider
      sections={props.content.attributes.body}
      menu={props.menu}
      slug={props.slug}
    >
      <TemplatePageComponent {...props} />
    </NavigationProvider>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  const slugs = await ApiEngine.pages.list();

  const paths = slugs.map((slug) => {
    return {
      params: {
        slug: slug,
      },
    };
  });

  return {
    paths: paths,
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps<ITemplatePageProps> = async (
  context
) => {
  const slug = context.params?.slug;
  if (typeof slug !== "string") {
    throw new Error("Slug undefined or wrong type");
  }
  try {
    const content = await ApiEngine.pages.getBySlug(slug);
    const menu = await ApiEngine.menu.getOrderedMenu();

    return {
      props: { menu, content, slug },
      revalidate: 30,
    };
  } catch (e) {
    console.error(e);
    return {
      notFound: true,
    };
  }
};

export default TemplatePage;
